<template>
  <div class="page" id="credits-buy">
    <div class="card">
      <div class="header">
        <div class="description">
          <h2 class="title">DETALHES DA ASSINATURA</h2>
          <p class="subtitle">Veja os detalhes da sua assinatura.</p>
        </div>

        <card-actions>
          <button
            @click="cancelSubscription"
            class="btn btn-danger -md md:mr-2"
            v-if="user.organizationPlan.cancellation_date === null"
          >Cancelar plano
            <ion-icon name="swap-horizontal-outline"></ion-icon>
          </button>
          <router-link
            :to="{name: 'Plans'}"
            class="btn btn-primary -md"
          >Alterar plano
            <ion-icon name="swap-horizontal-outline"></ion-icon>
          </router-link>
        </card-actions>
      </div>

      <div class="body">
        <div class="alert -danger" v-if="unrecognizedError">
          <template slot="title">Ops!</template>

          <p>Ocorreu um erro ao tentar realizar sua compra, tente novamente.</p>
        </div>

        <table>
          <thead>
          <tr>
            <th>Nome do Plano</th>
            <th>Valor por Consulta</th>
            <th>Valor do Plano</th>
            <th>Data da proxima cobrança</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ user.plan.name }}</td>
            <td>R$ {{ user.plan.price_per_consultation | currency }}</td>
            <td>R$ {{ user.plan.price / 100 }}</td>
            <td>{{ (user.organizationPlan.cancellation_date === null ? dateFormat(user.organizationPlan.next_charge_date, 'DD/MM/YYYY') : `Cancelado em ${dateFormat(user.organizationPlan.cancellation_date, 'DD/MM/YYYY')}`) }}</td>
          </tr>
          </tbody>
        </table>

        <p>
          <span class="relative" style="bottom: 6px">Recarga Automática</span>
        </p>

<!--        <div class="form-group" v-if="!disableRecharge">-->
        <div class="form-group" v-if="false">
          <money
            id="price"
            name="price"
            class="form-control"
            decimal=""
            thousands=""
            prefix="R$ "
            :precision="0"
            v-model="autoRechargeValue"
            autocomplete="off"
          />
          <button type="button" class="btn btn-success" @click="saveRechargeValue">
            <ion-icon name="save"></ion-icon>
          </button>

          <p class="text-sm mt-2 text-gray-600">* Recarrega automaticamente sua conta com um valor personalizado quando o saldo da conta cai abaixo de 5% do valor da assinatura. Isso garante que você nunca fique sem fundos, o que evita a interrupção inesperada do serviço.</p>
          <p class="text-sm mt-2 text-gray-600">** O valor deve ser maior que R$ 50 para que a recarga automatica esteja ativada, e R$ 0 para desativar. Click no botão para salvar a alteração do valor de recarga.</p>
        </div>

        <table>
          <thead>
          <tr>
            <th>Cartões de Crédito</th>
            <th class="text-right">
              <router-link :to="{name: 'AddPaymentMethod'}" class="btn btn-primary -sm">
                Adicionar <ion-icon name="add"></ion-icon>
              </router-link>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="paymentMethod in paymentMethods">
            <td>{{ paymentMethod.card.brand.toUpperCase() }} ****{{ paymentMethod.card.last4 }}</td>
            <td class="text-right">
              <button type="button" class="btn btn-danger -sm" v-if="paymentMethods.length > 1"
                @click="confirmDetachPaymentMethod(paymentMethod.id, `${paymentMethod.card.brand.toUpperCase()} ****${paymentMethod.card.last4}`)">
                <ion-icon name="trash"></ion-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>

        <p class="text-sm mt-2 text-gray-600">Se precisar remover um cartão, pode ser preciso adicionar um novo antes de realizar a exclusão.</p>

        <confirm-cancel-subscription ref="confirmCancelSubscription"/>
        <confirm-detach-payment-method ref="confirmDetachPaymentMethod" :card="selectedCardToDetach"/>
        <loader v-if="loading"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/support/components/Loader.vue';
import CardActions from '@/support/components/card/CardActions.vue';
import ConfirmCancelSubscription from '@/credits/components/ConfirmCancelSubscription.vue';
import ConfirmDetachPaymentMethod from '@/credits/components/ConfirmDetachPaymentMethod.vue';
import currency from '@/support/filters/currency';
import dateFormat from '@/support/filters/dateFormat';
import { Money } from 'v-money';

export default {
  name: 'PlanDetail',

  data() {
    return {
      unrecognizedError: false,
      loading: false,
      finished: false,
      autoRechargeValue: 0,
      selectedCardToDetach: '',
    };
  },

  async mounted() {
    this.loading = true;

    this.autoRechargeValue = this.user.organizationPlan.auto_recharge_value;

    await this.$store.dispatch('credits/paymentMethods');

    this.loading = false;
  },

  methods: {
    async confirmDetachPaymentMethod(cardId, cardName) {
      this.selectedCardToDetach = cardName;

      if (await this.$refs.confirmDetachPaymentMethod.confirm()) {
        this.loading = true;
        await this.$store.dispatch('credits/detachPaymentMethod', cardId);
        await this.$store.dispatch('credits/paymentMethods');
        this.loading = false;
      }
    },

    dateFormat(value, format) {
      return dateFormat(value, format);
    },

    async saveRechargeValue() {
      this.loading = true;

      try {
        await this.$store.dispatch('credits/autoRecharge', this.autoRechargeValue);

        this.user.organization.autoRechargeValue = this.autoRechargeValue;

        if (this.autoRechargeValue === 0) {
          this.showAutoRechargeValue = false;
        } else if (this.autoRechargeValue < 0) {
          this.autoRechargeValue *= -1;
        }

        this.loading = false;
        this.$notify({
          group: 'app',
          type: 'success',
          title: 'Valor de recarga salvo com sucesso.',
        });
      } catch ({ response }) {
        this.loading = false;
        if (response.status === 422) {
          this.$notify({
            group: 'app',
            type: 'warning',
            title: 'Valor de recarga deve ser no mínimo de R$ 50.',
            duration: 5000,
          });
        }
      }
    },

    async cancelSubscription() {
      if (await this.$refs.confirmCancelSubscription.confirm()) {
        try {
          this.loading = true;
          this.unrecognizedError = false;

          await this.$store.dispatch('credits/cancel');
          await this.$store.dispatch('auth/loadUser');
          this.$notify({
            group: 'app',
            type: 'success',
            title: 'Plano cancelado com sucesso.',
          });

          await this.$router.push({
            name: 'Plans',
          });
        } catch (e) {
          this.unrecognizedError = true;
        } finally {
          this.loading = false;
        }
      }
    },
  },

  computed: {
    ...mapState('auth', [
      'user',
    ]),
    ...mapState('credits', [
      'paymentMethods',
    ]),
    disableRecharge() {
      return this.user.plan && ['Plano de migração', 'Grátis'].includes(this.user.plan.name);
    },
  },

  components: {
    Loader,
    CardActions,
    ConfirmCancelSubscription,
    ConfirmDetachPaymentMethod,
    Money,
  },

  filters: {
    currency,
    dateFormat,
  },
};
</script>

<style>
.v-money {
  width: auto !important;
}
</style>
